module.exports = __webpack_public_path__ + "img/mobilepartyBanner.9d952538.png";